import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-j-checkbox',
    styles: [`:host {
        display: block;
        position: relative;
    }`],
    template: `<mat-checkbox [ngModel]="_value" (change)="UpdateValue($event)" [disabled]="disabled">
    <ng-content></ng-content></mat-checkbox>`,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JCheckboxComponent),
            multi: true
        }
    ]
})

export class JCheckboxComponent implements ControlValueAccessor {
    @Input() trueValue: any;
    @Input() falseValue: any;
    @Input() disabled: boolean;

    private onChange: Function;
    private onTouched: Function;

    _value: boolean;

    writeValue(value: any) {
        const self = this;

        // Take the value coming in from the model and set the internal material checkbox to either true or false depending on the value.
        let result = false;

        if ((self.trueValue != null && self.trueValue === value)
            || (self.trueValue == null && self.trueValue === true)) {
                result = true;
            }

        self._value = result;
    }

    registerOnChange(fn: Function) { this.onChange = fn; }

    registerOnTouched(fn: Function) { this.onTouched = fn; }

    setDisabledState(disabled: boolean) { this.disabled = disabled; }

    // #region Update Value Method

    UpdateValue(event: MatCheckboxChange) {
        const self = this;

        if (event) {
            const newval = event.checked;
            const model = (newval === true ? (self.trueValue != null ? self.trueValue : true) :
                (self.falseValue != null ? self.falseValue : false));

            // Push out the new value to Angular for binding
            if (self.onChange) { self.onChange(model); }
        }
    }

    // #endregion
}
